import { render, staticRenderFns } from "./wrongQue.vue?vue&type=template&id=614ab658&scoped=true&"
import script from "./wrongQue.vue?vue&type=script&lang=js&"
export * from "./wrongQue.vue?vue&type=script&lang=js&"
import style0 from "./wrongQue.vue?vue&type=style&index=0&id=614ab658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ab658",
  null
  
)

export default component.exports